import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const transgoormetCustomerGroup = 'goodbytz';
export const customerGroup = transgoormetCustomerGroup;

const supportEmail = 'goodbytz@smoothr.de';
const firebaseConfig = {
	goodbytz: {
		apiKey: 'AIzaSyDzRphheBb6PUySA_BeKRLmx_nym8cF9u4',
		authDomain: 'transgourmet-d715d.firebaseapp.com',
		projectId: 'transgourmet-d715d',
		storageBucket: 'transgourmet-d715d.appspot.com',
		messagingSenderId: '346931949800',
		appId: '1:346931949800:web:67fd907d74f0509191995d'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBJFXO1ZZEC401SqDKk7CVsxYM1L0aHBys',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['de'],
	hasRecommendations: true,
	showOrderPriceFromBackend: false,
	showDiffrenceModal: false,
	payPalValidatePrice: false,
	payPalMinPrice: 0
};
